import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_SUMMIT_API_BASE_ADDRESS,
    withCredentials: false,
    headers: { 'Content-Type': 'application/json',
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS'}
});

instance.defaults.headers.common['x-employeeId'] = 0;
instance.defaults.headers.common['x-employeeGuid'] = 'undefined';
instance.defaults.headers.common['x-jobTitle'] = 'undefined';
instance.defaults.headers.common['x-branchName'] = 'undefined';
instance.defaults.headers.common['Authorization'] = 'Bearer AUTH_TOKEN from msal';

export default instance;